<template>
  <div>
    <workbenchDetail
      @cancelCallBack="cancel"
      @approvalConfirm="approvalConfirm"
      :backlogModel="backlogModel"
      :isHide="isHide"
      width="800px"
    >
      <div slot="content">
        <el-form ref="form" label-width="150px" :model="dataForm">
          <el-form-item label="姓名：" prop="UserName">
            {{ dataForm.UserName }}
          </el-form-item>
          <el-form-item label="性别：" prop="Sex">
            {{ dataForm.Sex == 0 ? "女" : "男" }}
          </el-form-item>
          <el-form-item label="民族：" prop="National">
            {{ dataForm.National }}
          </el-form-item>
          <el-form-item label="出生日期：" prop="Birthday">
            {{ (dataForm.Birthday * 1000) | formatDate2 }}
          </el-form-item>
          <el-form-item label="手机号码：" prop="MobileNo">
            {{ dataForm.MobileNo }}
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="Email">
            {{ dataForm.Email }}
          </el-form-item>
          <el-form-item label="身份证号码：" prop="IdentityCard">
            {{ dataForm.IdentityCard }}
          </el-form-item>
          <el-form-item label="工作单位：" prop="WorkUnit">
            {{ dataForm.WorkUnit }}
          </el-form-item>
          <el-form-item label="职业：" prop="Occupation">
            {{ dataForm.Occupation }}
          </el-form-item>
          <el-form-item label="通讯地址：" prop="Address">
            {{ dataForm.Address }}
          </el-form-item>
          <el-form-item label="文化程度：" prop="Education">
            {{ showEducation(dataForm.Education) }}
          </el-form-item>
          <el-form-item label="政治面貌：" prop="Political">
            {{ showPolitical(dataForm.Political) }}
          </el-form-item>
          <el-form-item label="是否在校生：" prop="Political">
            {{ dataForm.IsSchool === 1?'是':'否' }}
          </el-form-item>
           <el-form-item label="学生证：" prop="File" v-if="dataForm.isSchool === 1 && dataForm.StudentCardFile">
            <el-image
              style="width: 150px; height: 100px"
              :src="dataForm.StudentCardFile"
              :preview-src-list="[dataForm.StudentCardFile]"
            >
            </el-image>
          </el-form-item>
          <el-form-item label="身份证：" prop="FrontImage">
            <div class="image-card">
              <div class="image-item" v-if="dataForm.FrontImage">
                <el-image
                  style="width: 150px; height: 100px"
                  :src="dataForm.FrontImage"
                  :preview-src-list="[dataForm.FrontImage]"
                />
              </div>
              <div class="image-item" v-if="dataForm.BackImage">
                  <el-image
                  style="width: 150px; height: 100px"
                  :src="dataForm.BackImage"
                  :preview-src-list="[dataForm.BackImage]"
                />
              </div>
            </div>
          </el-form-item>

          <el-form-item label="个人证件照：" prop="File" v-if="dataForm.File">
            <el-image
              style="width: 150px; height: 100px"
              :src="dataForm.File"
              :preview-src-list="[dataForm.File]"
            >
            </el-image>
          </el-form-item>

          <el-form-item label="会员级别：" prop="Level">
            {{ showLevel(dataForm.Level) }}
          </el-form-item>
          <el-form-item label="申请时间：" prop="ApplyTime">
            {{ (dataForm.ApplyTime * 1000) | formatDate }}
          </el-form-item>

          <el-form-item
            label="下载申请表："
            prop="ApplyFile"
            v-if="
              dataForm.ApplyFile !== '' &&
              dataForm.ApplyFile !== undefined &&
              dataForm.ApplyFile !== null
            "
          >
            <ul class="el-upload-list el-upload-list--fileList">
              <li
                v-for="(item, index) in fileListApplyFile"
                :key="index"
                @click="onFileApplyFile(item)"
                class="file-item"
              >
                <a
                  ><i class="el-icon-document" style="margin-right: 5px"></i
                  >{{ item.name }}</a
                >
              </li>
            </ul>
            <!-- <el-button type="danger" plain @click.native="sealClick()">盖电子章</el-button>
                        <el-button type="danger" plain @click.native="downloadClick()">下载电子文件</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </workbenchDetail>
    <el-dialog
      title="盖章"
      :visible.sync="dialogFile"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <iframe :scr="scrFile"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import { formatData } from "@/utils";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {}, //表单对象
      hideFileApplyFile: false,
      hideFrontImage: false,
      hideBackImage: false,
      dialogVisible: false,
      dialogImageUrl: "",
      FrontImage: [], //身份证正面
      BackImage: [], //身份证反面
      fileList: [], //生活照，
      fileListApplyFile: [], //盖章文件,
      dialogFile: false,
      scrFile: "",
    };
  },
  components: {
    workbenchDetail,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let vm = this;
      let params = { Id: vm.backlogModel.BusinessId };
      api.QueryPersonalMemberById(params).then((res) => {
        if (res.data.Code == 0) {
          vm.dataForm = res.data.Data;
          if (vm.dataForm.ApplyFile) {
            vm.fileListApplyFile = [{
              name: '（湛江）中国红十字会个人会员入会申请登记表.docx',
              url: vm.dataForm.ApplyFile
            }];
          }
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditPersonalMember(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //点击下载
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onFileApplyFile(file) {
      saveAs(file.url, file.name);
    },
    sealClick() {
      var fileId = "";
      var fileArr = [];
      if (this.dataForm.ApplyFile) {
        fileArr = JSON.parse(this.dataForm.ApplyFile);
        fileArr.map((item) => {
          fileId = item.fileId;
        });
      }
      let params = { Id: this.dataForm.Id, FileId: fileId };

      api.PersonalMemberUploadFile(params).then((res) => {
        window.open(res.data.Data, "_blank");
      });
    },
    downloadClick() {
      let params = { Id: this.dataForm.Id };
      api.PersonalMemberCreateCertPDF(params).then((res) => {
        const blob = new Blob([res.data]);
        saveAs(blob, "申请表.pdf");
      });
    },
    handleClose() {},
    showLevel(value) {
      return formatData(value, this.memberLevel);
    },
    showEducation(value) {
      return formatData(value, this.education);
    },
    showPolitical(value) {
      return formatData(value, this.political);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-item:hover {
  cursor: pointer;
  background-color: #f5f7fa;
}
.image-card {
  display: flex;
  .image-item {
    margin-right: 10px;
  }
}
</style>
